export const accountNumberValidationMessage =
  'Please enter an account number that starts with "A-" followed by 8 letters or numbers (e.g. A-1234ABCD). You can find it on your bills or letters from us.';
export const postcodeValidationMessage = 'Please enter a valid UK postcode';
export const surnameValidationMessage = 'Please enter your surname';

export const postcodeRegex = /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i;

export const validEmailAddressValidationMessage =
  'Please enter a valid email address';
export const requiredEmailAddressValidationMessage =
  'Please enter your email address';
export const requiredNewPasswordValidationMessage =
  'Please enter a new password';
export const requiredNewPasswordConfirmValidationMessage =
  'Please confirm your new password';
export const passwordConfirmDoesNotMatchValidationMessage =
  'This does not match your password';
